export default "__VITE_ASSET__vcEfK8wu__"